import { render, staticRenderFns } from "./DuplicateStep1ProjectDetails.vue?vue&type=template&id=8f521ffc&scoped=true&"
import script from "./DuplicateStep1ProjectDetails.vue?vue&type=script&lang=js&"
export * from "./DuplicateStep1ProjectDetails.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateStep1ProjectDetails.vue?vue&type=style&index=0&id=8f521ffc&scoped=true&lang=css&"
import style1 from "./DuplicateStep1ProjectDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f521ffc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f521ffc')) {
      api.createRecord('8f521ffc', component.options)
    } else {
      api.reload('8f521ffc', component.options)
    }
    module.hot.accept("./DuplicateStep1ProjectDetails.vue?vue&type=template&id=8f521ffc&scoped=true&", function () {
      api.rerender('8f521ffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/duplication/DuplicateStep1ProjectDetails.vue"
export default component.exports